import { lory } from "../../../../downloads/lory"
// import { redirect } from "../../utility"
import { loading } from "../../core/page-loader"
import StartComponent from './StartComponent.vue'
import PdfModal from '../../modals/PdfModal.vue'

$( document ).ready(function() {
    new Vue(require('../../components/StartPageVideo').default)
    new Vue(StartComponent)

    //SMOOTH LINKS
    $('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            let target = $(this.hash)
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']')
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - $('header').outerHeight() + 14
                }, 1000)
                return false
            }
        }
    })

    
    //Lory Slider
    const simple_dots = document.querySelector('.js_slider')
    lory(simple_dots, {
        infinite: 1,
        enableMouseEvents: true,
    })

     //Partner
    const $slickSlider = $('.partner-slick-slider')

    $slickSlider.slick({
        infinite: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        centerPadding: '60px',
        autoplay: true,
        autoplaySpeed: 1800,
        arrows: false,
        variableWidth: true,
        waitForAnimate: false,
        useCss: false,
        swipeToSlide: true,
        touchMove: true,
        touchThreshold: 100,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 610,
                settings: {
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]
    }).on('setPosition', function() {
        $(this).css('visibility','visible')
    })

    $slickSlider.css('display', 'block')

    $(window).on('load scroll', function() {
        var scroll = $(window).scrollTop()

        if (scroll >= $('#banner-slider-wrapper').height()-45) {
            $("#header")
                .addClass("in-position")
                .addClass("shadow")
        } else {
            $("#header")
                .removeClass("in-position")
                .removeClass("shadow")
        }
    })

    loading(false)
})